export default {
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
};
